<template>
    <div>
        <h1 class="display-heading">Referral System</h1>

        <div class="mb-5">
            <div class="card">
                <div class="card-header">
                    My Referral Link
                </div>
                <div class="card-body">

                    <div class="mb-3">
                        {{ referralUrl }}
                    </div>
                    <div>
                        <button v-if="referralUrl" class="btn btn-primary btn-primary-insv" @click="copyReferralCode">
                            Copy Link
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <h1 class="display-heading">My Referees</h1>
        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col>
                    <col width="250">
                    <col width="150">
                    <col width="150">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Email</th>
                            <th scope="col">Name</th>
                            <th scope="col">Referee Type</th>
                            <th scope="col">Joined Date</th>
                            <th scope="col">Level</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="list.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{ isTableLoading ? "Loading Data" : "No Data" }}
                            </td>
                        </tr>
                        <tr v-for="(data, index) in list" :key="index">
                            <td>
                                {{ index + 1 }}
                            </td>
                            <td>
                                {{ data.entityEmail ? data.entityEmail : '-' }}
                            </td>
                            <td>
                                {{ data.entityName ? data.entityName : '-' }}
                            </td>
                            <td>
                                {{ getReferralEntityName(data.entityType) }}
                            </td>
                            <td>
                                {{ data.joinedDate ? convertToUserReadableDate(data.joinedDate) : '-' }}
                            </td>
                            <td>
                                {{  data.level }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { convertToUserReadableDate } from '@/utilities';
export default {
    'name': 'ReferralModule',
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'referralUrl': '',
            'referralCode': '',
            'list': []
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        this.getMyReferralCode();
        this.getList();
    },
    'methods': {
        getMyReferralCode () {
            this.axios.get('referral/mycode').then((res) => {
                const data = res.data.data;
                this.referralUrl = data.shareUrl;
                this.referralCode = data.code;
            });
        },
        getList () {
            this.axios.get('referral/list').then((res) => {
                this.isTableLoading = false;
                this.list = res.data.data;
            });
        },
        copyReferralCode () {
            const el = document.createElement('textarea');
            el.value = this.referralUrl;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        },
        getReferralEntityName (entity) {
            if (entity === 1) {
                return 'Individual';
            } else if (entity === 2) {
                return 'Company';
            } else if (entity === 3) {
                return 'Clinic';
            } else {
                return 'Unknown';
            }
        },
        convertToUserReadableDate
    }
};
</script>
